<div class="row">
  <div class="col-8">
    <h3 style="text-align: right;">Zone Wise Count</h3>
  </div>
  <div class="col" style="text-align: right;">
    <button mat-raised-button (click)="closeComponent()" style="color: white; background: red;">CLOSE</button>
  </div>
</div><br>
<div *ngIf="!is_data_available">
  <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [value]="value">
  </mat-progress-spinner>
</div>
<div class="row" *ngIf="zone_wise_data !== null">
  <div class="col">
    <mat-accordion>
      <mat-expansion-panel *ngFor="let zone of zone_wise_data['zone_list']"
        style="margin-top: 6px; margin-bottom: 15px; border-radius: 8px;">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ zone['name']}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row">
          <div class="col-3">Overall Count</div>
          <div class="col-3">Ord. Via Counter</div>
          <div class="col-3">Online Orders</div>
          <div class="col-3">Unord. count</div>
        </div>
        <div class="row">
          <div class="col-3">{{zone_wise_data['zone_with_count_dict'][zone['id']]['ovellall_business_count']}}</div>
          <div class="col-3">{{zone_wise_data['zone_with_count_dict'][zone['id']]['orderered_business_via_portal']}}
          </div>
          <div class="col-3">{{zone_wise_data['zone_with_count_dict'][zone['id']]['orderered_business_via_mobile']}}
          </div>
          <div class="col-3">{{zone_wise_data['zone_with_count_dict'][zone['id']]['unordered_business_count']}}</div>
        </div>
        <hr style="background: lightgrey;">
        <div *ngFor="let business_type of business_type_list" class="row">
          <div class="col"
            *ngIf="zone_wise_data['zone_with_count_dict'][zone['id']]['un_ordered_list'].hasOwnProperty(business_type.id)">
            <div style="font-size: 16px;" (click)="expandClicked(business_type.id)" style="cursor: pointer;"
              class="row">
              <div class="col">
                Pending
                {{business_type['name']}}'s
                ({{zone_wise_data['zone_with_count_dict'][zone['id']]['un_ordered_list'][business_type.id].length}})
              </div>
              <div class="col-3">
                <span class="material-icons" *ngIf="selected_business_type_id == business_type.id">
                  keyboard_arrow_up
                </span>
                <span class="material-icons" *ngIf="selected_business_type_id != business_type.id">
                  keyboard_arrow_down
                </span>
              </div>
            </div>
            <span *ngIf="selected_business_type_id == business_type.id">
              <div class="row" style="background: antiquewhite; padding: 5px;">
                <div class="col-2">S.No</div>
                <div class="col-3">Booth code</div>
                <div class="col">Agent name</div>
              </div>
              <div class="row" style="padding: 5px;"
                *ngFor="let business of zone_wise_data['zone_with_count_dict'][zone['id']]['un_ordered_list'][business_type.id]; let business_index=index">
                <div class="col-2">{{business_index + 1}}</div>
                <div class="col-3">{{business['business_code']}}</div>
                <div class="col">{{business['agent_first_name']}} {{business['agent_last_name']}}</div>
              </div>
            </span>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
